/**
 * Allowlist of RTK Query mutation endpoint names that the offline mutation
 * queue is permitted to enqueue and replay.
 *
 * Inclusion criteria (Phase 1):
 *  - The endpoint accepts a client-supplied id (so replay is idempotent-ish).
 *  - The server's failure mode on duplicate id is classifiable (see
 *    `classifyReplayResult` in `mutation-queue.ts`).
 *  - Tags and ACLs ride along on `updateEntity` patches — they aren't
 *    distinct endpoints in `entitiesApi`, so they're covered transitively.
 */
export const queueableEndpoints = ['updateEntity', 'createEntity', 'deleteEntity'] as const
export type QueueableEndpoint = (typeof queueableEndpoints)[number]
export const isQueueableEndpoint = (name: string): name is QueueableEndpoint =>
  (queueableEndpoints as readonly string[]).includes(name)
